import { z } from 'zod';
/** Route params for every endpoint addressing one organization, including its nested routers. */
export const OrganizationIdParamsSchema = z.object({ organizationId: z.uuid() }).strict();
//# sourceMappingURL=params.js.map